<template>
  <md-card class="md-layout" v-if="userId && challenge">
    <h3 slot="header">Challenge-Registrierung bearbeiten</h3>
    <md-card-content class="md-layout-item md-size-100">
      <dynamic-form
          ref="joinForm"
          :formFields="joinFormFields"
          @update="updatedFields($event)"
          :hideSubmit="true">
      </dynamic-form>
      <dynamic-form
          ref="additionalForm"
          v-if="additionalFormFields && additionalFormFields.length"
          :formFields="additionalFormFields"
          @update="updatedAddFields($event)"
          :hideSubmit="true"
      />
      <!-- ADD additionFORM -->
    </md-card-content>
    <md-card-actions class="md-layout-item md-size-100">
      <md-button class="mr-5 cancel-button" @click="goToRoute('/Challenges/' + challengeId)">
        {{$t('general.cancel')}}
      </md-button>
      <md-button class="md-success" @click="submitEditForm">
        {{$t('general.save')}}
      </md-button>
    </md-card-actions>
  </md-card>
</template>

<script>
import {mapState} from "vuex";
import DynamicForm from "@/components/DynamicForm/DynamicForm";

export default {
  components: { DynamicForm },
  data() {
    return {
      challengeId: this.$route.params.id,
      challenge: undefined,
      joinFormFields: [],
      additionalFormData: null,
      additionalFormFields: null,
      myCode: null,
      updatedChallengeRegistration: {},
    }
  },
  computed: {
    ...mapState({
      userId: state => state.user && state.user._id,
    })
  },
  mounted() {
    this.$store
        .dispatch("queryAPI", {url: "/rest/challenge/" + this.challengeId + "?v=1"})
        .then(res => {
          this.challenge = res;
          if (res.joined.find(u => u.userId === this.userId)) {
            this.$store
                .dispatch("loadMyLeaderboard", {
                  challengeId: this.challengeId
                })
                .then(res => {
                  if (res.code) {
                    this.myCode = res.code;
                    this.editJoinFrom();
                  }
                  const joinForm = this.challenge.joinForm.fields || [];
                  const overrideFields = res.data || [];
                  this.additionalFormData = res.additionalFormData || [];
                  //empty pre-filled fields we get from the challenge join form
                  let emptiedFields = joinForm.map(formField => {
                    let emptiedField = null;
                    if (formField.name && formField.value) {
                      emptiedField = { ...formField, value: null };
                    }
                    if (formField.name=="code") {
                      emptiedField = { ...formField, disabled: true }
                    }
                    return emptiedField ? { ...formField, ...emptiedField } : formField;
                  });
                  this.joinFormFields = emptiedFields.map(formField => {
                    let overrideField;
                    if (formField.name) {
                      overrideField = overrideFields.find(
                          f => f.name && formField.name === f.name
                      );
                    }
                    //TODO: Data are not being updated, check why is not being updated. Data are comming correctly from backend.
                    else if (formField.children) {
                      formField.children.forEach(child => {
                        overrideField = overrideFields.find( f => {
                              return f.name && child.name === f.name
                            })
                      })
                    }

                    return overrideField
                        ? { ...formField, ...overrideField }
                        : formField;
                  });
                });
          }
        })
        .catch(err => {
          this.$notify({
            timeout: 5000,
            message: err.message,
            icon: "add_alert",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger"
          });
        });
  },
  methods: {
    async isEditFormValid() {
      const isValid =  !this.$refs.joinForm || await this.$refs.joinForm.validate();
      return isValid;
    },
    async editJoinFrom() {
      // extrem sample is RegId: 612ca41a99962d7f463923ba - with voucherCode
      console.log(this.code, ' code')
        const codeInfo = await this.$api.checkJoinCode(this.myCode||"");
        this.additionalFormFields = codeInfo.joinForm && codeInfo.joinForm.additionalFields;

        // set default values for joinForm from CODE
        if (codeInfo.joinForm && codeInfo.joinForm.fields && codeInfo.joinForm.fields.length > 0) {
          this.joinFormFields = this.joinFormFields.map(formField => {
            const overrideField = codeInfo.joinForm.fields.find(
                f => f.name && formField.name === f.name
            );
            return overrideField
                ? { ...formField, ...overrideField }
                : formField;
          });
        }
        // http://localhost:3030/rest/challenge/checkCode/6107b7aaf8f6eb446d171219/RLCAG2D9
        if (this.additionalFormData && this.additionalFormFields) {
          const additionalFormData = this.additionalFormData;

          let emptiedFields = this.additionalFormFields.map(formField => {
            let emptiedField = null;
            if (formField.name && formField.value) {
              emptiedField = { ...formField, value: null };
            }
            return emptiedField ? { ...formField, ...emptiedField } : formField;
          });

          this.additionalFormFields = emptiedFields.map(formField => {
            if (additionalFormData[formField.name]) {
              formField.value = additionalFormData[formField.name];
            }
            return formField;
          });
        }
    },
    updatedFields(data) {
      this.updatedChallengeRegistration.data = data;
    },
    updatedAddFields(data) {
      this.updatedChallengeRegistration.additionalFormData = data;
    },
    async submitEditForm() {
      if (await this.isEditFormValid()) {
        this.$store
            .dispatch("postAPI", {
              url: `/rest/challenge/${this.challenge._id}/registration/`,
              method: "PATCH",
              data: this.updatedChallengeRegistration
            })
            .then(res => {
              this.goToRoute('/Challenges/'+this.challenge._id);
              this.$notify({
                timeout: 5000,
                message: "Erfogleicht bearbeitet",
                type: "success",
                horizontalAlign: "right",
                verticalAlign: "top",
              });
            })
            .catch(err => {
              this.$notify({
                timeout: 5000,
                message: err.message,
                type: "error",
                horizontalAlign: "right",
                verticalAlign: "top",
              });
            });
      }
    },
  }
}
</script>